import { useEffect } from "react";

import { PUBLIC_LINK } from "@/components/public/control-classes";

interface ExternalLocation {
  replace: (url: string) => void;
}

function replaceExternalLocation(
  url: string,
  location: ExternalLocation = window.location,
) {
  location.replace(url);
}

export function ExternalRedirect({
  to,
  location = window.location,
}: {
  to: string;
  location?: ExternalLocation;
}) {
  useEffect(() => {
    replaceExternalLocation(to, location);
  }, [location, to]);

  return (
    <main className="grid min-h-screen place-items-center bg-background px-6 text-foreground">
      <p className="text-center text-ui text-muted-foreground">
        Continuing to public admissions. <a className={`${PUBLIC_LINK} text-primary underline`} href={to}>Continue now</a>
      </p>
    </main>
  );
}
